export default {
  title: 'LA PAGE QUE VOUS RECHERCHEZ EST FORCÉMENT ICI QUELQUE PART...',
  description: "Cherchez-vous l'une des pages ci-dessous ?",
  not_found: "Nous ne trouvons pas l'URL saisie. Veuillez vérifier qu'elle est correcte.",
  no_restaurants: {
    title: "Cette boutique n'accepte pas encore les commandes en ligne",
    description: 'Revenez bientôt.',
  },
  toasts: {
    failed_to_load_stores: 'Impossible de charger les restaurants, veuillez actualiser la page',
  },
};
